import angular from 'angular';

export default class QueryBuilderChildrenGroupController {
	/* @ngInject */
	constructor() {
		/** @type {boolean} */
		this.dropdownOpened = false;

		/** @type {?import('~/scripts/services/model/query-where-child').default} */
		this.group = null;

		/** @type {?QueryBuilderChildrenGroupController} */
		this.parent = null;

		/** @type {?import('../query-builder-children/query-builder-children.controller').default} */
		this.parentBuilder = null;
	}

	dropdownFixPosition() {
		const $uibPosition = this.parentBuilder?.$uibPosition;
		this.parentBuilder?.$timeout(() => {
			const dropdownMenu = angular.element('.dropdown-query-builder-children-group:visible');
			if (dropdownMenu) {
				dropdownMenu.css('bottom', '');
				// @ts-ignore
				const offset = $uibPosition?.viewportOffset(dropdownMenu.get(0));
				if (offset.bottom < 0) {
					dropdownMenu.css('bottom', '0');
				}
			}
		});
	}

	/**
	 * @param {boolean} open
	 */
	dropdownToogle(open) {
		if (open) {
			this.dropdownFixPosition();
		}
	}

	removeGroup() {
		if (this.parentBuilder && this.group) {
			if (this.parent?.group) {
				this.parentBuilder.removeGroup(this.group, this.parent.group);
			}
			else {
				this.parentBuilder.removeGroup(this.group, this.parentBuilder.group);
			}
		}
	}

	$onInit() {
		this.parentBuilder?.$scope.$watch('$ctrl.loadingChildrenNodes', (
			/** @type {boolean} */ newValue,
			/** @type {boolean} */ oldValue,
		) => {
			if (oldValue === true && newValue === false && this.dropdownOpened) {
				this.dropdownFixPosition();
			}
		});
	}
}
